/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step5Inputs */

const en_landing_workflow_step5 = /** @type {(inputs: Landing_Workflow_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const de_landing_workflow_step5 = /** @type {(inputs: Landing_Workflow_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const fr_landing_workflow_step5 = /** @type {(inputs: Landing_Workflow_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const es_landing_workflow_step5 = /** @type {(inputs: Landing_Workflow_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const it_landing_workflow_step5 = /** @type {(inputs: Landing_Workflow_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const nl_landing_workflow_step5 = /** @type {(inputs: Landing_Workflow_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const pl_landing_workflow_step5 = /** @type {(inputs: Landing_Workflow_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const fi_landing_workflow_step5 = /** @type {(inputs: Landing_Workflow_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const da_landing_workflow_step5 = /** @type {(inputs: Landing_Workflow_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const sv_landing_workflow_step5 = /** @type {(inputs: Landing_Workflow_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Landing_Workflow_Step5Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_workflow_step5 = /** @type {((inputs?: Landing_Workflow_Step5Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step5Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_workflow_step5(inputs)
	if (locale === "fr") return fr_landing_workflow_step5(inputs)
	if (locale === "es") return es_landing_workflow_step5(inputs)
	if (locale === "it") return it_landing_workflow_step5(inputs)
	if (locale === "nl") return nl_landing_workflow_step5(inputs)
	if (locale === "pl") return pl_landing_workflow_step5(inputs)
	if (locale === "fi") return fi_landing_workflow_step5(inputs)
	if (locale === "da") return da_landing_workflow_step5(inputs)
	if (locale === "sv") return sv_landing_workflow_step5(inputs)
	return en_landing_workflow_step5(inputs)
});